import React, { useEffect } from "react";
import "./chatbotdetails.scss";
import Input from "../../../../components/input";
import Chooseimage from "../chooseimage";
import Button from "../../../../components/button";
import CopyIcon from "../../../../assets/icons/copy.svg";
import ReloadIcon from "../../../../assets/icons/reload.svg";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import {
  changeProjectVisibility,
  refreshApiKey,
  setFocusedProject,
  setSelectedProject,
  updateBrand,
} from "../../../../store/slices/projectSlice";
import toast from "react-hot-toast";
import ImageInput from "../../../../common/file/ImageInput";
import { base64ToBlob } from "../../../../common/validation";
import Conformation from "../../../../components/modal/conformation";
import UpdateIcon from "../../../../assets/icons/update.svg";
import KBSelection from "../../../../components/kbselection";

export default function Chatbotdetails({ isKnowledgeChat }) {
  const { selectedProject, focusedProject } = useSelector(
    (state) => state.project
  );
  const dispatch = useDispatch();

  const [isApiKeyUpdateModal, setIsApiKeyModal] = useState(false);

  // Use database-backed value from selectedProject
  // Removed Individual/Company toggle - showing all fields by default

  const [copiedUrl, setCopiedUrl] = useState(false);
  const [addImageModal, setAddImgesModal] = useState(false);
  // const [uploadedBackgroundImg, setUploadedBackgroundImg] = useState(); // Unused
  const [loading, setLoading] = useState(false);
  const [uploadedImage, setuploadedImage] = useState();
  const { origin } = window.location;

  useEffect(() => {
    dispatch(setSelectedProject(focusedProject));
  }, [dispatch, focusedProject]);
  const handleOnChnage = (e) => {
    const { name, value, files } = e.target;
    if (
      name === "bot_image" ||
      name === "background_image" ||
      name === "welcome_image"
    ) {
      if (name === "background_image") {
        setuploadedImage(files[0]);
        setAddImgesModal(true);
        return;
      }
      dispatch(setSelectedProject({ ...selectedProject, [name]: files[0] }));

      return;
    }

    dispatch(setSelectedProject({ ...selectedProject, [name]: value }));
  };
  const handleOnSubmit = () => {
    // Validate: If Knowledge Chat mode is active, require at least one KB document
    // Check embedding_count from the project data (set by backend) OR if user just saved the KB selection
    const hasKBDocuments = (selectedProject?.embedding_count && selectedProject.embedding_count > 0);

    if (isKnowledgeChat && !hasKBDocuments) {
      toast.error('Please save your Knowledge Base selection first (click "Save Selection" above).');
      return;
    }

    setLoading(true);
    let formData = new FormData();
    Object.keys(selectedProject).forEach((key) => {
      if (key === "id") {
        formData.append("project_id", selectedProject[key]);
      } else if (key === "quick_links" || key === "form_config") {
        formData.append(key, JSON.stringify(selectedProject[key]));
      } else {
        formData.append(key, selectedProject[key]);
      }
    });

    formData.append("answer_limit", "10");
    dispatch(updateBrand(formData))
      .unwrap()
      .then((res) => {
        if (!res?.data?.success) {
          setLoading(false);
          // Show error message if backend returned failure
          if (res?.data?.message) {
            toast.error(res.data.message);
          }
          return;
        }
        if (res?.data?.success) {
          setLoading(false);
          toast.success(res?.data?.message);
        }
      })
      .catch((error) => {
        setLoading(false);
        // Handle validation errors and other exceptions
        const errorMessage = error?.data?.message || error?.message || "Failed to update project settings";
        toast.error(errorMessage);
      });
  };
  const handleVisibility = () => {
    const body = {
      id: selectedProject?.id,
      is_published: !selectedProject?.is_published,
    };
    dispatch(changeProjectVisibility(body))
      .unwrap()
      .then((res) => {
        dispatch(
          setSelectedProject({
            ...selectedProject,
            is_published: res?.data?.data?.is_published,
          })
        );
        dispatch(
          setFocusedProject({
            ...focusedProject,
            is_published: res?.data?.data?.is_published,
          })
        );
      });
  };
  const handleCopyText = (data) => {
    navigator.clipboard.writeText(data);
    setCopiedUrl(true);
    setTimeout(() => {
      setCopiedUrl(false);
    }, 500);
  };
  const handleOnClickReset = () => {
    dispatch(setSelectedProject(focusedProject));
  };

  const handleRefreshApiKey = () => {
    let body = {
      id: selectedProject?.id,
    };
    dispatch(refreshApiKey(body))
      .unwrap()
      .then((res) => {
        if (!res?.data?.success) {
          toast.error(res?.data?.message);
          return;
        }
        handleCloseModal();
        toast.success(res?.data?.message);
      });
  };
  const handleOnRemoveChatBotIcon = (name) => {
    dispatch(
      setSelectedProject({ ...selectedProject, [name]: focusedProject[name] })
    );

    // setUploadedBackgroundImg("");
    // Also clear if needed, though this generic reset relies on focusedProject
    if (name === "welcome_image") {
      // Additional logic if needed, but the dispatch above handles resetting to focusedProject value
    }
  };
  const [imageData, setImageData] = useState("");

  useEffect(() => {
    if (imageData) {
      var file = base64ToBlob(imageData?.photo?.src);
      // setUploadedBackgroundImg(file);
      dispatch(setSelectedProject({ ...selectedProject, background_image: file }));
      setImageData("");
    }
  }, [dispatch, imageData, selectedProject]);

  const handleCloseModal = () => {
    setIsApiKeyModal(false);
  };

  let compareObject =
    JSON.stringify(selectedProject)?.replace(/ /g, "") ===
    JSON.stringify(focusedProject)?.replace(/ /g, "");
  return (
    <div className="chatbot-details-all-contnet-alignment">
      <h5>Chatbot</h5>
      <div className="box">
        {/* Individual/Company toggle removed - showing all fields */}
        <div className="two-col-grid">
          <Input
            label="Bot Name"
            placeholder="RTA"
            name={"bot_name"}
            value={selectedProject?.bot_name}
            onChange={handleOnChnage}
            limit={25}
          />
          <Input
            label="Powered By Branding"
            placeholder="Brand Name"
            name={"project_moto"}
            value={selectedProject?.project_moto}
            onChange={handleOnChnage}
            limit={40}
            autoComplete="off"
          />
          <Input
            label="Brand Link"
            placeholder="https://..."
            name={"agent_name"}
            value={selectedProject?.agent_name}
            onChange={handleOnChnage}
            autoComplete="off"
          />
          {/* <Input label="Bot text colour"/> */}
          <div className="input">
            <label>Bot text colour</label>
            <select
              placeholder="Black"
              name={"text_color"}
              value={selectedProject?.text_color}
              onChange={handleOnChnage}
            >
              <option value={"white"}>White</option>
              <option value={"black"}>Black</option>
            </select>
          </div>
          {/* Color Mode Toggle */}
          <div className="input-field-container">
            <label className="input-label" style={{ marginBottom: '8px', display: 'block', fontWeight: '100', color: '#fff' }}>Bot Color Type</label>
            <div style={{
              display: 'inline-flex',
              background: 'rgba(255, 255, 255, 0.05)',
              padding: '4px',
              borderRadius: '8px',
              border: '1px solid rgba(255, 255, 255, 0.1)'
            }}>
              <button
                type="button"
                onClick={() => {
                  const solidColor = selectedProject?.base_color?.includes("gradient") ? "#008000" : (selectedProject?.base_color || "#008000");
                  handleOnChnage({ target: { name: "base_color", value: solidColor } });
                }}
                style={{
                  padding: '8px 24px',
                  borderRadius: '6px',
                  border: 'none',
                  background: !selectedProject?.base_color?.includes("gradient") ? '#fff' : 'transparent',
                  color: !selectedProject?.base_color?.includes("gradient") ? '#111' : '#ccc',
                  boxShadow: !selectedProject?.base_color?.includes("gradient") ? '0 2px 4px rgba(0,0,0,0.1)' : 'none',
                  fontWeight: '500',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease'
                }}
              >
                Solid Color
              </button>
              <button
                type="button"
                onClick={() => {
                  if (!selectedProject?.base_color?.includes("gradient")) {
                    const defaultGradient = "linear-gradient(to right, #79376f, #ff0000)";
                    handleOnChnage({ target: { name: "base_color", value: defaultGradient } });
                  }
                }}
                style={{
                  padding: '8px 24px',
                  borderRadius: '6px',
                  border: 'none',
                  background: selectedProject?.base_color?.includes("gradient") ? '#fff' : 'transparent',
                  color: selectedProject?.base_color?.includes("gradient") ? '#111' : '#ccc',
                  boxShadow: selectedProject?.base_color?.includes("gradient") ? '0 2px 4px rgba(0,0,0,0.1)' : 'none',
                  fontWeight: '500',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease'
                }}
              >
                Gradient
              </button>
            </div>
          </div>

          {/* Conditional Rendering based on Mode */}
          {!selectedProject?.base_color?.includes("gradient") ? (
            /* SOLID COLOR INPUT */
            <div className="col-full solid-color-wrapper" style={{ marginTop: '15px' }}>
              <Input
                type={"color"}
                label="Bot Solid Color"
                placeholder="#7fb8b2"
                name={"base_color"}
                value={selectedProject?.base_color || "#008000"}
                onChange={handleOnChnage}
              />
            </div>
          ) : (
            /* GRADIENT BUILDER UI */
            <div className="gradient-builder col-full" style={{
              marginTop: '15px',
              padding: '20px',
              border: '1px solid rgba(255, 255, 255, 0.15)',
              borderRadius: '12px',
              background: 'transparent',
              marginBottom: '20px'
            }}>
              <label className="input-label" style={{ marginBottom: '16px', display: 'block', fontWeight: '600', color: '#fff' }}>Gradient Configuration</label>

              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginBottom: '20px' }}>
                {/* Start Color */}
                <div>
                  <label style={{ fontSize: '13px', color: '#ccc', marginBottom: '6px', display: 'block' }}>Start Color</label>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px', background: 'rgba(255,255,255,0.05)', padding: '8px', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '8px' }}>
                    <input
                      type="color"
                      style={{ width: '40px', height: '40px', border: 'none', padding: 0, background: 'none', cursor: 'pointer' }}
                      value={(() => {
                        // ROBUST PARSING: rgb(r, g, b) -> hex
                        try {
                          const str = selectedProject?.base_color || "";
                          const rgbMatches = str.match(/rgb\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/g);
                          if (rgbMatches && rgbMatches[0]) {
                            // Found rgb, convert to hex
                            const nums = rgbMatches[0].match(/\d+/g);
                            if (nums) return "#" + ((1 << 24) + (+nums[0] << 16) + (+nums[1] << 8) + +nums[2]).toString(16).slice(1);
                          }
                          // Fallback simple hex extraction attempts
                          const parts = str.split(/,(?![^(]*\))/); // split by comma NOT inside parens
                          const color = parts[1]?.trim();
                          if (color?.startsWith('#')) return color;
                          return "#79376f";
                        } catch (e) { return "#79376f" }
                      })()}
                      onChange={(e) => {
                        // Reconstruct Gradient
                        const str = selectedProject?.base_color || "";
                        // Basic Parse
                        const parts = str.match(/linear-gradient\((.*)\)/)?.[1]?.split(/,(?![^(]*\))/);
                        let dir = parts?.[0]?.trim() || "to right";
                        let end = parts?.[parts.length - 1]?.trim() || "#ff0000";
                        // Remove any percentage or ')' from end color if present
                        if (end.includes(')')) end = end.replace(')', '').replace(/[\d%]+$/, '').trim();

                        const newGrad = `linear-gradient(${dir}, ${e.target.value}, ${end})`;
                        handleOnChnage({ target: { name: "base_color", value: newGrad } });
                      }}
                    />
                    <span style={{ fontSize: '12px', color: '#fff', fontFamily: 'monospace' }}>
                      {/* Display Hex Value being picked */}
                      {(() => {
                        const str = selectedProject?.base_color || "";
                        const rgbMatches = str.match(/rgb\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/g);
                        if (rgbMatches && rgbMatches[0]) {
                          const nums = rgbMatches[0].match(/\d+/g);
                          if (nums) return ("#" + ((1 << 24) + (+nums[0] << 16) + (+nums[1] << 8) + +nums[2]).toString(16).slice(1)).toUpperCase();
                        }
                        const parts = str.split(/,(?![^(]*\))/);
                        return (parts[1] || "#79376F").trim().toUpperCase();
                      })()}
                    </span>
                  </div>
                </div>

                {/* End Color */}
                <div>
                  <label style={{ fontSize: '13px', color: '#ccc', marginBottom: '6px', display: 'block' }}>End Color</label>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px', background: 'rgba(255,255,255,0.05)', padding: '8px', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '8px' }}>
                    <input
                      type="color"
                      style={{ width: '40px', height: '40px', border: 'none', padding: 0, background: 'none', cursor: 'pointer' }}
                      value={(() => {
                        try {
                          const str = selectedProject?.base_color || "";
                          const rgbMatches = str.match(/rgb\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/g);
                          if (rgbMatches && rgbMatches[1]) { // Use second rgb match
                            const nums = rgbMatches[1].match(/\d+/g);
                            if (nums) return "#" + ((1 << 24) + (+nums[0] << 16) + (+nums[1] << 8) + +nums[2]).toString(16).slice(1);
                          }
                          const parts = str.split(/,(?![^(]*\))/);
                          let last = parts[parts.length - 1]?.trim();
                          // Clean potential '100% )'
                          if (last && last.includes(')')) last = last.replace(')', '').replace(/[\d%]+$/, '').trim();
                          if (last?.startsWith('#')) return last;
                          return "#ff0000";
                        } catch (e) { return "#ff0000" }
                      })()}
                      onChange={(e) => {
                        const str = selectedProject?.base_color || "";
                        const parts = str.match(/linear-gradient\((.*)\)/)?.[1]?.split(/,(?![^(]*\))/);
                        let dir = parts?.[0]?.trim() || "to right";
                        let start = parts?.[1]?.trim() || "#79376f";

                        const newGrad = `linear-gradient(${dir}, ${start}, ${e.target.value})`;
                        handleOnChnage({ target: { name: "base_color", value: newGrad } });
                      }}
                    />
                    <span style={{ fontSize: '12px', color: '#fff', fontFamily: 'monospace' }}>
                      {/* Display End Hex */}
                      {(() => {
                        try {
                          const str = selectedProject?.base_color || "";
                          const rgbMatches = str.match(/rgb\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/g);
                          if (rgbMatches && rgbMatches[1]) {
                            const nums = rgbMatches[1].match(/\d+/g);
                            if (nums) return ("#" + ((1 << 24) + (+nums[0] << 16) + (+nums[1] << 8) + +nums[2]).toString(16).slice(1)).toUpperCase();
                          }
                          const parts = str.split(/,(?![^(]*\))/);
                          let last = parts[parts.length - 1]?.trim();
                          if (last && last.includes(')')) last = last.replace(')', '').replace(/[\d%]+$/, '').trim();
                          return (last || "#FF0000").toUpperCase();
                        } catch (e) { return "#FF0000" }
                      })()}
                    </span>
                  </div>
                </div>
              </div>

              {/* Direction */}
              <div style={{ marginBottom: '20px' }}>
                <label style={{ fontSize: '13px', color: '#ccc', marginBottom: '6px', display: 'block' }}>Direction</label>
                <select
                  style={{
                    width: '100%',
                    padding: '10px 12px',
                    borderRadius: '8px',
                    border: '1px solid rgba(255,255,255,0.1)',
                    background: 'rgba(255,255,255,0.05)',
                    fontSize: '14px',
                    color: '#fff',
                    cursor: 'pointer'
                  }}
                  value={(() => {
                    try {
                      const str = selectedProject?.base_color || "";
                      const parts = str.match(/linear-gradient\((.*)\)/)?.[1]?.split(/,(?![^(]*\))/);
                      return parts?.[0]?.trim() || "to right";
                    } catch (e) { return "to right" }
                  })()}
                  onChange={(e) => {
                    const str = selectedProject?.base_color || "";
                    const parts = str.match(/linear-gradient\((.*)\)/)?.[1]?.split(/,(?![^(]*\))/);
                    let start = parts?.[1]?.trim() || "#79376f";
                    let end = parts?.[2]?.trim() || "#ff0000";
                    // Clean potential ')' from end color if present
                    if (end.includes(')')) end = end.replace(')', '').replace(/[\d%]+$/, '').trim();

                    const newGrad = `linear-gradient(${e.target.value}, ${start}, ${end})`;
                    handleOnChnage({ target: { name: "base_color", value: newGrad } });
                  }}
                >
                  <option value="to right">Left to Right (⮕)</option>
                  <option value="to left">Right to Left (⬅)</option>
                  <option value="to bottom">Top to Bottom (⬇)</option>
                  <option value="to top">Bottom to Top (⬆)</option>
                  <option value="to bottom right">Diagonal (Top-Left ⮕ Btm-Right)</option>
                  <option value="to bottom left">Diagonal (Top-Right ⮕ Btm-Left)</option>
                </select>
              </div>

              {/* Preview */}
              <div>
                <label style={{ fontSize: '13px', color: '#ccc', marginBottom: '6px', display: 'flex', justifyContent: 'space-between' }}>
                  Preview
                  <span style={{ fontSize: '11px', color: '#888', fontWeight: '400' }}>Actual CSS Value</span>
                </label>
                <div style={{
                  height: '48px',
                  borderRadius: '8px',
                  background: selectedProject?.base_color,
                  border: '1px solid rgba(255,255,255,0.1)',
                  boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.05)'
                }}></div>
                <div style={{
                  fontSize: '11px',
                  color: '#aaa',
                  marginTop: '6px',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  fontFamily: 'monospace',
                  background: 'rgba(255,255,255,0.05)',
                  padding: '4px 8px',
                  borderRadius: '4px',
                  border: '1px solid rgba(255,255,255,0.05)'
                }}>
                  {selectedProject?.base_color}
                </div>
              </div>
            </div>
          )}

          <div className="col-full">
            <Input
              label="Welcome message"
              placeholder="Hello there!s Welcome to our community!"
              name={"welcome_title"}
              value={selectedProject?.welcome_title}
              onChange={handleOnChnage}
            />
          </div>
        </div>


        {/* Knowledge Base Configuration */}
        <KBSelection projectId={selectedProject?.id} />

        {/* New Configuration Section */}
        <div className="configuration-section" style={{ marginTop: '30px' }}>

          {/* Welcome Message (Subtitle) */}


          {/* Quick Links Configuration */}
          <div className="quick-links-config" style={{ marginBottom: '30px', background: 'rgba(255,255,255,0.02)', padding: '20px', borderRadius: '12px', border: '1px solid rgba(255,255,255,0.1)' }}>
            <h6 style={{ color: '#fff', marginBottom: '15px' }}>Quick Links</h6>

            {/* Existing Links List */}
            {selectedProject?.quick_links?.length > 0 && (
              <div className="existing-links" style={{ marginBottom: '15px' }}>
                {selectedProject.quick_links.map((link, index) => (
                  <div key={index} style={{ display: 'flex', gap: '10px', marginBottom: '10px', alignItems: 'center' }}>
                    <input
                      value={link.label}
                      onChange={(e) => {
                        const newLinks = [...(selectedProject.quick_links || [])];
                        newLinks[index] = { ...newLinks[index], label: e.target.value };
                        handleOnChnage({ target: { name: 'quick_links', value: newLinks } });
                      }}
                      style={{ flex: 1, padding: '8px', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', color: '#fff', borderRadius: '6px' }}
                    />
                    <input
                      value={link.url}
                      onChange={(e) => {
                        const newLinks = [...(selectedProject.quick_links || [])];
                        newLinks[index] = { ...newLinks[index], url: e.target.value };
                        handleOnChnage({ target: { name: 'quick_links', value: newLinks } });
                      }}
                      style={{ flex: 2, padding: '8px', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', color: '#aaa', borderRadius: '6px' }}
                    />
                    <button
                      onClick={() => {
                        const newLinks = selectedProject.quick_links.filter((_, i) => i !== index);
                        handleOnChnage({ target: { name: 'quick_links', value: newLinks } });
                      }}
                      style={{ background: '#ff4444', color: '#fff', border: 'none', borderRadius: '6px', padding: '8px 12px', cursor: 'pointer' }}
                    >
                      X
                    </button>
                  </div>
                ))}
              </div>
            )}

            {/* Add New Link */}
            <div className="add-link-form" style={{ display: 'flex', gap: '10px', alignItems: 'flex-end' }}>
              <div style={{ flex: 1 }}>
                <label style={{ display: 'block', color: '#ccc', fontSize: '12px', marginBottom: '4px' }}>Label</label>
                <input
                  id="new-link-label"
                  placeholder="e.g. Website"
                  style={{ width: '100%', padding: '10px', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', color: '#fff', borderRadius: '6px' }}
                />
              </div>
              <div style={{ flex: 2 }}>
                <label style={{ display: 'block', color: '#ccc', fontSize: '12px', marginBottom: '4px' }}>URL (or automated response)</label>
                <input
                  id="new-link-url"
                  placeholder="https://... or Text Response"
                  style={{ width: '100%', padding: '10px', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', color: '#fff', borderRadius: '6px' }}
                />
              </div>
              <button
                onClick={() => {
                  const labelInput = document.getElementById('new-link-label');
                  const urlInput = document.getElementById('new-link-url');
                  if (labelInput.value && urlInput.value) {
                    const newLink = { label: labelInput.value, url: urlInput.value }; // 'url' here can store the text response too
                    const currentLinks = selectedProject?.quick_links || [];
                    handleOnChnage({ target: { name: 'quick_links', value: [...currentLinks, newLink] } });
                    labelInput.value = '';
                    urlInput.value = '';
                  }
                }}
                style={{ background: 'var(--gradient-primary)', color: '#fff', border: 'none', borderRadius: '6px', padding: '10px 20px', cursor: 'pointer', height: 'fit-content' }}
              >
                Add
              </button>
            </div>
          </div>

          {/* Form Configuration */}
          {/* Form Configuration */}
          <div className="form-config" style={{ marginBottom: '30px', background: 'rgba(255,255,255,0.02)', padding: '20px', borderRadius: '12px', border: '1px solid rgba(255,255,255,0.1)' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
              <h6 style={{ color: '#fff', margin: 0 }}>Lead Form Fields</h6>
              <button
                onClick={() => {
                  const currentConfig = Array.isArray(selectedProject?.form_config)
                    ? selectedProject.form_config
                    : []; // Migrate or start fresh
                  const newField = { label: "New Field", type: "text", placeholder: "Enter value" };
                  handleOnChnage({ target: { name: 'form_config', value: [...currentConfig, newField] } });
                }}
                style={{ background: 'var(--gradient-primary)', color: '#fff', border: 'none', borderRadius: '6px', padding: '6px 12px', cursor: 'pointer', fontSize: '12px' }}
              >
                + Add Field
              </button>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
              {(() => {
                let currentConfig = selectedProject?.form_config;
                if (typeof currentConfig === 'string') {
                  try { currentConfig = JSON.parse(currentConfig); } catch (e) { currentConfig = []; }
                }
                const configArray = Array.isArray(currentConfig) ? currentConfig : [];

                return configArray.map((field, idx) => (
                  <div key={idx} style={{ display: 'flex', gap: '10px', alignItems: 'center', background: 'rgba(255,255,255,0.05)', padding: '10px', borderRadius: '8px' }}>
                    <div style={{ flex: 1 }}>
                      <label style={{ fontSize: '10px', color: '#aaa', display: 'block', marginBottom: '2px' }}>Label</label>
                      <input
                        value={field.label || ""}
                        onChange={(e) => {
                          const newConfig = [...selectedProject.form_config];
                          newConfig[idx] = { ...newConfig[idx], label: e.target.value };
                          handleOnChnage({ target: { name: 'form_config', value: newConfig } });
                        }}
                        style={{ width: '100%', background: 'transparent', border: 'none', borderBottom: '1px solid rgba(255,255,255,0.2)', color: '#fff', fontSize: '14px' }}
                        placeholder="Label"
                      />
                    </div>
                    <div style={{ width: '100px' }}>
                      <label style={{ fontSize: '10px', color: '#aaa', display: 'block', marginBottom: '2px' }}>Type</label>
                      <select
                        value={field.type || "text"}
                        onChange={(e) => {
                          const newConfig = [...selectedProject.form_config];
                          newConfig[idx] = { ...newConfig[idx], type: e.target.value };
                          handleOnChnage({ target: { name: 'form_config', value: newConfig } });
                        }}
                        style={{ width: '100%', background: '#333', border: 'none', color: '#fff', fontSize: '14px', borderRadius: '4px', padding: '2px' }}
                      >
                        <option value="text">Text</option>
                        <option value="email">Email</option>
                        <option value="tel">Phone</option>
                        <option value="number">Number</option>
                        <option value="textarea">Long Text</option>
                      </select>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '2px', minWidth: '60px' }}>
                      <label style={{ fontSize: '10px', color: '#aaa', display: 'block' }}>Mandatory</label>
                      <label className="modern-switch" style={{ position: 'relative', display: 'inline-block', width: '34px', height: '20px' }}>
                        <input
                          type="checkbox"
                          checked={field.required || false}
                          onChange={(e) => {
                            const newConfig = [...selectedProject.form_config];
                            newConfig[idx] = { ...newConfig[idx], required: e.target.checked };
                            handleOnChnage({ target: { name: 'form_config', value: newConfig } });
                          }}
                          style={{ opacity: 0, width: 0, height: 0 }}
                        />
                        <span className="slider round" style={{ 
                          position: 'absolute', cursor: 'pointer', top: 0, left: 0, right: 0, bottom: 0, 
                          backgroundColor: field.required ? '#6366f1' : '#444', transition: '.4s', borderRadius: '34px' 
                        }}>
                          <span className="dot" style={{ 
                            position: 'absolute', height: '14px', width: '14px', left: field.required ? '17px' : '3px', 
                            bottom: '3px', backgroundColor: 'white', transition: '.4s', borderRadius: '50%' 
                          }}></span>
                        </span>
                      </label>
                    </div>
                    <button
                      onClick={() => {
                        const newConfig = selectedProject.form_config.filter((_, i) => i !== idx);
                        handleOnChnage({ target: { name: 'form_config', value: newConfig } });
                      }}
                      style={{ background: '#ff4444', border: 'none', borderRadius: '4px', width: '24px', height: '24px', color: '#fff', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                    >
                      ×
                    </button>
                  </div>
                ));
              })()}

              {(!Array.isArray(selectedProject?.form_config) || selectedProject?.form_config?.length === 0) && (
                <div style={{ color: '#aaa', fontSize: '13px', fontStyle: 'italic', padding: '10px' }}>
                  No fields configured. Click "Add Field" to verify.
                  <button
                    onClick={() => {
                      // Restore defaults
                      const defaults = [
                        { label: "Name", type: "text", placeholder: "Enter your Name*", required: true },
                        { label: "Mobile Number", type: "tel", placeholder: "Mobile*", required: true },
                        { label: "Email ID", type: "email", placeholder: "Email*", required: true },
                        { label: "Course", type: "text", placeholder: "Course Interested*", required: true }
                      ];
                      handleOnChnage({ target: { name: 'form_config', value: defaults } });
                    }}
                    style={{ display: 'block', marginTop: '10px', background: 'transparent', border: '1px dashed #777', color: '#ccc', padding: '5px 10px', borderRadius: '4px', cursor: 'pointer' }}
                  >
                    Convert / Restore Defaults
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="new-drop-grid">
          <Chooseimage
            name={"bot_image"}
            onChange={handleOnChnage}
            label={"Chatbot Icon"}
            value={selectedProject?.bot_image}
            onRemove={() => handleOnRemoveChatBotIcon("bot_image")}
            imageValue={selectedProject?.bot_image}
          />
          {/* <Chooseimage
            name={"background_image"}
            onChange={handleOnChnage}
            label={"Background Image"}
            value={selectedProject?.background_image}
            imageValue={uploadedBackgroundImg}
            onRemove={() => handleOnRemoveChatBotIcon("background_image")}
          /> */}

          <Chooseimage
            name={"welcome_image"}
            onChange={handleOnChnage}
            label={"Welcome Photo"}
            value={selectedProject?.welcome_image}
            onRemove={() => handleOnRemoveChatBotIcon("welcome_image")}
            imageValue={selectedProject?.welcome_image}
          />

          <ImageInput
            imageData={imageData?.photo?.src}
            type="admin"
            name="photo"
            label="Add Photo"
            showPreview
            onChange={(files) => setImageData(files, "admin")}
            fileData={uploadedImage}
            setAddImgesModal={setAddImgesModal}
            addImageModal={addImageModal}
            style={{ display: 'none' }}
          />
        </div>
        {/* Buttons moved to bottom - after Agent fields */}
        <div className="button-alignment" style={{ marginTop: '20px' }}>
          <Button
            text="Save changes"
            onClick={handleOnSubmit}
            loader={loading}
            disabled={compareObject}
          />
          <Button
            text="Reset to default"
            onClick={handleOnClickReset}
            className="outline"
          />
        </div>
      </div>

      <div
        className="sub-box"
        title={
          compareObject
            ? "Please save your changes or click reset to perform this action!"
            : ""
        }
      >
        <div
          className="two-col"
          style={{
            pointerEvents: !compareObject ? "none" : "all",
            opacity: compareObject ? 1 : 0.6,
          }}
        >
          <Input
            label="Visibile to public"
            icon={CopyIcon}
            switchtoogle={true}
            isSwitchTrue={selectedProject?.is_published}
            handleVisibility={handleVisibility}
            // iconClick={handleVisibility}
            iconClick={() => {
              selectedProject?.is_published &&
                handleCopyText(
                  `${origin}/${isKnowledgeChat ? "chat" : "generalchat"}/${selectedProject?.api_key
                  }`
                );
            }}
            value={`${origin}/${isKnowledgeChat ? "chat" : "generalchat"}/${selectedProject?.api_key
              }`}
            placeholder="https://dribbble.com/following"
            disabled={!selectedProject?.is_published}
            isPointerNone={!selectedProject?.is_published || !compareObject}
            copiedUrl={copiedUrl}
          />
          <div>
            <p>Project specific API key</p>
            {/* <span>{selectedProject?.api_key}</span> */}
            <div className="refersh" onClick={() => setIsApiKeyModal(true)}>
              <img src={ReloadIcon} alt="ReloadIcon" />
            </div>
          </div>
        </div>
      </div>

      <Conformation
        title={"Refresh Api Key"}
        btnText={"Confirm"}
        onClick={handleRefreshApiKey}
        onClose={() => handleCloseModal()}
        message={
          "Are you sure, you want to generate new key for this project? If you click confirm your old link will expired"
        }
        icon={UpdateIcon}
        isModal={isApiKeyUpdateModal}
      />
    </div >
  );
}
